module.exports = __webpack_public_path__ + "media/lifesum-intro-no-820c5311.mp4";